export default __webpack_public_path__ + "strikethrough.png";